"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var pickers_1 = require("@material-ui/pickers");
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Chevron_1 = require("../../atoms/Chevron/Chevron");
var Divider_1 = require("../../atoms/Divider/Divider");
var Icon_1 = require("../../atoms/Icon/Icon");
var MenuItem_1 = require("../../atoms/MenuItem/MenuItem");
var Popover_1 = require("../../atoms/Popover/Popover");
var TextField_1 = require("../../atoms/TextField/TextField");
var DatePicker_logic_1 = require("./DatePicker.logic");
var DatePicker_static_1 = require("./DatePicker.static");
var DatePicker_style_1 = require("./DatePicker.style");
/**
 * DatePicker molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-datepicker--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/DatePicker Source}
 */
var DatePicker = function (props) {
    var _a = (0, DatePicker_logic_1.useDatePicker)(props), classes = _a.classes, isDatePickerVisible = _a.isDatePickerVisible, isExactDateSelected = _a.isExactDateSelected, openDatePicker = _a.openDatePicker, chevronProps = _a.chevronProps, menuOptions = _a.menuOptions, pickerProps = _a.pickerProps, textFieldProps = _a.textFieldProps, popoverProps = _a.popoverProps;
    return ((0, jsx_runtime_1.jsxs)(core_1.ThemeProvider, __assign({ theme: DatePicker_style_1.datePickerTheme }, { children: [(0, jsx_runtime_1.jsx)(TextField_1.TextField, __assign({}, textFieldProps, { endAdornment: renderEndAdornment() })), renderPopper()] })));
    function renderEndAdornment() {
        return (0, jsx_runtime_1.jsx)(Chevron_1.Chevron, __assign({ color: theme_1.default.textColors.primary, height: 7, className: classes.chevron }, chevronProps));
    }
    function renderPopper() {
        return ((0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({ popoverPosition: 'bottom left', popoverOffset: 4, canAppearOutOfWindow: false, overflow: 'hidden' }, popoverProps, { children: isDatePickerVisible ? renderDatePicker() : renderMenu() })));
    }
    function renderDatePicker() {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.datePicker }, { children: (0, jsx_runtime_1.jsx)(pickers_1.Calendar, __assign({}, pickerProps)) })));
    }
    function renderMenu() {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("ul", __assign({ className: classes.menuList }, { children: menuOptions.map(function (option) { return ((0, jsx_runtime_1.jsx)(MenuItem_1.MenuItem, __assign({ selectable: true, onClick: option.onClick, selected: option.selected }, { children: option.text }), option.text)); }) })), (0, jsx_runtime_1.jsx)(Divider_1.Divider, { margin: { top: 0, right: 20, bottom: 0, left: 20 } }, 'divider'), (0, jsx_runtime_1.jsx)("ul", __assign({ className: classes.menuList }, { children: (0, jsx_runtime_1.jsxs)(MenuItem_1.MenuItem, __assign({ selectable: true, onClick: openDatePicker, selected: isExactDateSelected }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: classes.icon, color: isExactDateSelected ? theme_1.default.textColors.highlight : theme_1.default.textColors.primary, hoverVariant: 'default', iconPath: icons_1.default.calendarCompact }), isExactDateSelected ? DatePicker_static_1.localText.exactDate : DatePicker_static_1.localText.selectDate] }), 'select-date') }))] }));
    }
};
exports.DatePicker = DatePicker;
